import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ThreeDSecureRequest, ThreeDSecureResponse} from '@core/services/operations/operations.model'
import { ApiService } from '@core/services/api/api.service';

@Injectable()
export class ThreeDSecureService {
  constructor(
    private apiService: ApiService,
  ) {}

  сhecService(request: ThreeDSecureRequest): Observable<ThreeDSecureResponse> {
    return this.apiService.post<ThreeDSecureResponse,ThreeDSecureRequest>(`rest/personal/threeDSecurity/check`, request);
  }

  threeDSecureEnable(request: ThreeDSecureRequest): Observable<ThreeDSecureResponse> {
    return this.apiService.post<ThreeDSecureResponse,ThreeDSecureRequest>(`rest/personal/threeDSecurity/activate`, request);
  }

  threeDSecureDisable(request: ThreeDSecureRequest): Observable<ThreeDSecureResponse> {
    return this.apiService.post<ThreeDSecureResponse,ThreeDSecureRequest>(`rest/personal/threeDSecurity/deactivate`, request);
  }
}
